
import { useState, useEffect, useCallback } from 'react';

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  const checkDeviceType = useCallback(() => {
    const width = window.innerWidth;
    setIsMobile(width < 768);
    setIsTablet(width >= 768 && width < 1024);
    setIsDesktop(width >= 1024);
  }, []);

  useEffect(() => {
    checkDeviceType(); // Check on initial load
    window.addEventListener('resize', checkDeviceType);

    return () => {
      window.removeEventListener('resize', checkDeviceType);
    };
  }, [checkDeviceType]);

  return { isMobile, isTablet, isDesktop };
};

// For components that need just the boolean value
export const useMobileCheck = () => {
  const { isMobile } = useIsMobile();
  return isMobile;
};

export default useIsMobile;
